import Skeleton from 'react-loading-skeleton';

const IntroContainerSkeleton = () => {
  return (
    <section className="mx-auto w-1/2 rounded-lg bg-white-100 p-4 bp2:p-6">
      <Skeleton count={1} className="my-6" height={32} />
      <Skeleton count={2} className="my-2" height={32} />
    </section>
  );
};

export default IntroContainerSkeleton;
